module.exports = __webpack_public_path__ + "media/images/category/dummy/accessory04-9caab7d7b0cba704efa6fbd045703e29.jpg";